import { paperStyles } from '../../libs/paperStyles'

export const HorizontalDivider = () => (
  <div className={paperStyles({ borders: ['top'] })} />
)
